<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">

      <a-form-model-item prop="money" >
        <span slot="label" >
          <a-tooltip>
            {{$t('用户提现.提现金额')}}<template slot="title">{{$t('用户提现.提现金额')}}</template>
          </a-tooltip>
        </span>
        <a-input-number :min="0.01" :max="Number(shopBalance)" style="width: 50%" v-model="form.money"  :placeholder="$t('通用.输入.请输入')+$t('用户提现.提现金额')" />
        <span> 余额 : {{shopBalance}}</span>
      </a-form-model-item>

<!--      <a-form-model-item prop="withdrawType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('用户提现.提现方式')}}<template slot="title">{{$t('用户提现.提现方式')}}</template>
          </a-tooltip>
        </span>
        <a-select :placeholder="$t('通用.输入.请选择')+$t('用户提现.提现方式')" v-model="form.withdrawType" allowClear >
          <a-select-option  value="1">{{$t('用户提现.支付宝')}}</a-select-option>
          <a-select-option  value="2">{{$t('用户提现.微信')}}</a-select-option>
          <a-select-option  value="3">{{$t('用户提现.银行卡')}}</a-select-option>
        </a-select>
      </a-form-model-item>-->
      <a-form-model-item prop="accountNum" >
        <span slot="label" >
          <a-tooltip>
            结算账户<template slot="title">结算账户</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.accountNum" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'结算账户'" />
      </a-form-model-item>

      <a-form-model-item prop="accountName" >
        <span slot="label" >
          <a-tooltip>
            真实姓名<template slot="title">真实姓名</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.accountName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'真实姓名'" />
      </a-form-model-item>
      <a-form-model-item prop="accountBankPhone" >
        <span slot="label" >
          银行预留手机号
        </span>
        <a-input v-model="form.accountBankPhone" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'银行预留手机号'" />
      </a-form-model-item>
      <a-form-model-item prop="accountBank" >
        <span slot="label" >
          结算开户行
        </span>
        <a-input v-model="form.accountBank" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'结算开户行'" />
      </a-form-model-item>
      <a-form-model-item prop="accountBankName" >
        <span slot="label" >
          <a-tooltip>
            结算开户银行支行名称<template slot="title">结算开户银行支行名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.accountBankName" :maxLength="128" placeholder="结算开户银行支行名称" />
      </a-form-model-item>
      <a-form-model-item prop="accountBankAddress" >
        <span slot="label" >
          结算开户银行所在地
        </span>
        <a-input v-model="form.accountBankAddress" :maxLength="128" :placeholder="$t('通用.输入.请输入')+'结算开户银行所在地'" />
      </a-form-model-item>



      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWithdraw, addWithdraw, updateWithdraw,shopBalance,shopDefaultBank } from '@/api/shop/shopWithdraw'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      shopBalance: 0,
      // 表单参数
      form: {
        id: null,

        userId: null,

        shopId: null,

        money: null,

        status: 0,

        accountNum: null,

        accountName: null,
        accountBankName: null,
        accountBank : null,
        accountBankPhone: null,
        accountBankAddress: null,
        serviceChargeNum: null,

        withdrawType: "3",

        withdrawUserType: null,

        orderNo: null,

        failureReason: null,

        auditOpinion: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
    this.getAmount();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    getAmount() {
      //查询可提现的金额
      shopBalance().then(response => {
        this.shopBalance = response.data
      })
    },

    getDefaultBank() {
      //查询可提现的金额
      shopDefaultBank().then(response => {
        if (response.data) {
          this.form.withdrawType = "3"
          this.form.accountNum = response.data.settlementBankAccountNumber
          this.form.accountName = response.data.settlementBankUserName
          this.form.accountBankName = response.data.settlementBankName
          this.form.accountBank = response.data.settlementBankAccountName
          this.form.accountBankPhone = response.data.bankUserPhone
          this.form.accountBankAddress = response.data.settlementBankAddress
        }
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        shopId: null,
        money: null,
        status: 0,
        accountNum: null,
        accountName: null,
        accountBank : null,
        accountBankPhone: null,
        accountBankAddress: null,
        accountBankName: null,
        serviceChargeNum: null,
        withdrawType: "3",
        withdrawUserType: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        createTime: null,
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
      this.getDefaultBank()
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWithdraw({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.按钮.审核')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateWithdraw(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addWithdraw(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
